module.exports = __webpack_public_path__ + "img/tpd.acce4a0c.svg";